<script lang="ts" module>
  export type ErrorType =
    | 'general'
    | 'sdkVersionMismatch'
    | 'payment_authentication_failed'
    | 'payment_invalid'
    | 'payment_declined'
    | 'invalid_card_details'
    | 'insufficient_funds'
    | 'processing_error'
    | 'invalid_request'
    | 'account_issue'
    | 'unsupported'
    | 'rate_limited'
    | 'unknown';
  let errorType = $state<undefined | ErrorType>();
  export const setGlobalError = (errType: ErrorType = 'general') => {
    errorType = errType;
  };
</script>

<script lang="ts">
  import Modal from '@athena-lib/Modal/Modal.svelte';
  import { Error } from '@athena-lib/Icons';
  import { Text } from '@athena-lib/Text';
  import { ButtonLink, Button } from '@athena-lib/Button';
  import { getCommonTranslations } from '@athena-lib/commonTranslationsContext';
  import clsx from 'clsx';
  import type { ExpandedCheckoutSettings } from '$lib/server/expanders/checkoutSettingsExpander';
  const {
    errorTitle,
    errorDescription,
    errorButtonText,
    errorButtonLink,
  }: ExpandedCheckoutSettings = $props();
  const translations = getCommonTranslations();

  const title = $derived(
    errorType === 'sdkVersionMismatch'
      ? translations.sdkVersionMismatchTitle
      : (errorTitle ?? translations.anErrorHasOccured),
  );

  const message = $derived(
    errorType === 'sdkVersionMismatch' ? translations.sdkVersionMismatchMessage : errorDescription,
  );
</script>

<Modal
  size="sm"
  showModal={errorType !== undefined}
  closable={errorType !== 'sdkVersionMismatch'}
  onClose={() => {
    if (errorType !== 'sdkVersionMismatch') {
      errorType = undefined;
    }
  }}
>
  <div class={clsx('flex gap-6 px-6 pb-6', errorType === 'sdkVersionMismatch' ? 'pt-6' : 'pt-0')}>
    <div class=""><Error sizeClass={clsx('size-6')} /></div>
    <div class="flex flex-grow flex-col gap-8">
      <div class="flex flex-grow flex-col gap-2">
        {#if title}
          <Text element="span" size="medium">
            {title}
          </Text>
        {/if}
        {#if message}
          <Text element="p" size="xsmall">
            {message}
          </Text>
        {/if}
      </div>
      <div class="flex flex-wrap justify-end gap-2">
        {#if errorType === 'sdkVersionMismatch'}
          <Button
            size="small"
            data-initialfocus="true"
            color="dark"
            onClick={() => {
              document.location.reload();
            }}>{translations.refreshPage}</Button
          >
        {/if}
        {#if errorButtonLink && errorButtonText}
          <ButtonLink size="small" link={{ href: errorButtonLink }} color="brand"
            >{errorButtonText}</ButtonLink
          >
        {/if}
      </div>
    </div>
  </div>
</Modal>
